import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  go: (
    <PortalMessage
      id='t.app.go.linkShort'
      defaultMessage='Vai'
    />
  ),
  attention: (
    <PortalMessage
      id='t.app.attention'
      defaultMessage='Attenzione'
    />
  ),
  goToNpgDescriptionModal: (
    <PortalMessage
      id='t.app.mobileSso.goToNpgDescriptionModal'
      defaultMessage='Verrai reindirizzato al portale di backoffice, se non dovesse accadere clicca su "Vai"'
    />
  )
}

export default formattedMessage
